import React from 'react';
import PropTypes from 'prop-types';
import withMobileDialog from '@material-ui/core/withMobileDialog';

import {
  Button,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
} from '../index';

const ConfirmationDialog = ({
  className,
  open,
  title,
  children,
  confirmDisabled,
  cancelButtonText,
  confirmButtonText,
  handleCancel,
  handleConfirm,
  maxWidth,
  ...rest,
}) => {
  return (
    <div>
      <Dialog
        disableBackdropClick
        disableEscapeKeyDown
        maxWidth={maxWidth}
        open={open}
        {...rest}
      >
        <DialogTitle >{title}</DialogTitle>
        <DialogContent >
          {children}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleCancel} color="secondary">
            {cancelButtonText}
          </Button>
          <Button onClick={handleConfirm} disabled={confirmDisabled || false} color="secondary" autoFocus>
            {confirmButtonText}
          </Button>
        </DialogActions>
      </Dialog>
    </div>
  );
}

ConfirmationDialog.defaultProps = {
  maxWidth: 'sm',
  title: '',
  cancelButtonText: '',
  confirmButtonText: '',
  confirmDisabled: false,
  handleCancel: () => {},
  handleConfirm: () => {},
}

ConfirmationDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  title: PropTypes.oneOfType([
    PropTypes.string,
    PropTypes.node,
  ]),
  cancelButtonText: PropTypes.string,
  confirmButtonText: PropTypes.string,
  confirmDisabled: PropTypes.bool,
  handleCancel: PropTypes.func,
  handleConfirm: PropTypes.func,
  maxWidth: PropTypes.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false]),
}

export default withMobileDialog({breakpoint: 'xs'})(ConfirmationDialog);



// WEBPACK FOOTER //
// ./src/components/base/ConfirmationDialog/ConfirmationDialog.js